import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import "../../styles/receptionist/receptionists.css";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../../components/common-components/CommonStructured";
import { fetchReceptionistsData } from "../../redux/prospect-reducers/prospectSlice";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import ReceptionistListings from "../../components/receptionists/ReceptionistListings";
import ReceptionistForm from "../../components/receptionists/ReceptionistForm";

const Receptionists = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);

  const { receptionistsLoading } = useSelector((state) => state.prospects);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";

  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(userInfoData?.account_type);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    isActive: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    status: allFilters.isActive?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniModvalues = {
    isModOpen: false,
    rowData: "",
    modName: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  function onCloseModal() {
    setModValues(iniModvalues);
  }

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getReceptionists(filters) {
    dispatch(
      fetchReceptionistsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getReceptionists(filters);
  }, [filters]);

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym: !isAdmin && !isClusterManager
  //       ? {
  //           label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
  //           value:
  //             userInfoData?.gym_id ||
  //             userInfoData?.user_id ||
  //             userInfoData?.uid ||
  //             "",
  //         }
  //       : "",
  //   }));
  // }, [userInfoData?.gym_id]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      status: allFilters.isActive?.value || "",
    }));
  }, [isPage, pageLimit, allFilters.selectedGym, allFilters.isActive]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Receptionist Management">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Detail Modal"
          ariaHideApp={false}
        >
          <div className={`createNewCTOModalContainer`}>
            {/* <ModalHeadAndClose
              title={modValues.modName?.replace(/_/g, " ")}
              onClose={onCloseModal}
            /> */}

            {modValues.modName === "edit" ? (
              <ReceptionistForm
                userInfoData={userInfoData}
                isEdit={modValues.modName === "edit"}
                rowData={modValues.rowData}
                closeModal={onCloseModal}
                callFunction={() => getReceptionists(filters)}
              />
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Receptionist Management"}
              isReload={() => getReceptionists(filters)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <CmnFilters
              from={"receptionists"}
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              isLoading={receptionistsLoading}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <ReceptionistListings
              userInfoData={userInfoData}
              isPage={isPage}
              setIsPage={(value) => setIsPage(value)}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              callFunction={() => {
                getReceptionists(filters);
              }}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default Receptionists;
